import { queryOptions } from '@tanstack/react-query'
import { formatUnits } from 'viem'
import { merklApiClient } from '../api-client'
import { PointsLeaderboardEntry } from '../types'
import { NormalizedUnitNumber } from '@/domain/types/NumericValues'
import { POINTS_LEADERBOARD_ITEMS, POINTS_TOKEN_ADDRESS } from '@/config/chain/points'

export function pointsLeaderboardQueryOptions(chainId: number) {
  return queryOptions({
    queryKey: pointsLeaderboardQueryKey(),
    queryFn: async (): Promise<PointsLeaderboardEntry[]> => {
      const response = await merklApiClient.getLeaderboard({
        address: POINTS_TOKEN_ADDRESS,
        chainId,
        items: POINTS_LEADERBOARD_ITEMS,
      })

      return response.data.map((entry, index): PointsLeaderboardEntry => {
        const amount = NormalizedUnitNumber(formatUnits(BigInt(entry.amount) * 100n, 18))
        const formattedAmount = Number(amount).toLocaleString(undefined, {
          maximumFractionDigits: 2,
        })

        return {
          recipient: entry.recipient,
          amount,
          formattedAmount,
          ranking: index + 1,
          points: amount,
        }
      })
    },
  })
}

export function pointsLeaderboardQueryKey(): unknown[] {
  return ['merkl', 'points-leaderboard']
}
